import { render, staticRenderFns } from "./informDialog.vue?vue&type=template&id=453b3d88&scoped=true"
import script from "./informDialog.vue?vue&type=script&lang=js"
export * from "./informDialog.vue?vue&type=script&lang=js"
import style0 from "./informDialog.vue?vue&type=style&index=0&id=453b3d88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b3d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453b3d88')) {
      api.createRecord('453b3d88', component.options)
    } else {
      api.reload('453b3d88', component.options)
    }
    module.hot.accept("./informDialog.vue?vue&type=template&id=453b3d88&scoped=true", function () {
      api.rerender('453b3d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicineFind/components/informDialog.vue"
export default component.exports